import { render, staticRenderFns } from "./pluginPropEdit.vue?vue&type=template&id=d6318492&scoped=true&"
import script from "./pluginPropEdit.vue?vue&type=script&lang=ts&"
export * from "./pluginPropEdit.vue?vue&type=script&lang=ts&"
import style0 from "./pluginPropEdit.vue?vue&type=style&index=0&id=d6318492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6318492",
  null
  
)

export default component.exports